import { values } from './enums'

const MessagesTabs = {
  DRAFT: 'draft',
  SENT: 'sent'
}

const VALUES = values(MessagesTabs)

export {
  MessagesTabs,
  VALUES
}



// WEBPACK FOOTER //
// ./src/enums/MessagesTabs.js